const menuItemFormParamFreq = {
  day: 'days',
  month: 'months'
};

export default menuItemFormParamFreq;
